const BENEFIT_MEMBER_DISCOUNT = 2
const BENEFIT_POINT_BOOSTER = 3

export interface SvipChargeRuleValue {
    charge_type: number
    charge?: number | string | null
    status?: boolean
}

export const SVIP_CHARGE_TYPE_MAP: Record<number, string> = {
    0: '月卡',
    1: '季卡',
    2: '年卡',
}

const getChargeAmount = (rule?: SvipChargeRuleValue) => Number(rule?.charge || 0)

export const validateSvipChargeRuleOrder = (rules: SvipChargeRuleValue[] = []) => {
    const sortedRules = [...(rules || [])].sort((a, b) => a.charge_type - b.charge_type)
    for (let index = 1; index < sortedRules.length; index++) {
        const previousCharge = getChargeAmount(sortedRules[index - 1])
        const currentCharge = getChargeAmount(sortedRules[index])
        if (currentCharge < previousCharge) {
            return `${SVIP_CHARGE_TYPE_MAP[sortedRules[index].charge_type]}费用不能小于${
                SVIP_CHARGE_TYPE_MAP[sortedRules[index - 1].charge_type]
            }费用`
        }
    }

    return ''
}

export const hasSvipChargeRuleAmountChanged = (
    rules: SvipChargeRuleValue[] = [],
    originRules: SvipChargeRuleValue[] = [],
) =>
    (rules || []).some(rule => {
        const originRule = (originRules || []).find(item => item.charge_type === rule.charge_type)

        return !originRule || getChargeAmount(originRule) !== getChargeAmount(rule)
    })

export const getSvipChargeRuleSyncOrder = <T extends SvipChargeRuleValue>(
    rules: T[] = [],
    originRules: SvipChargeRuleValue[] = [],
) => {
    const changedRules = (rules || []).filter(rule => {
        const originRule = (originRules || []).find(item => item.charge_type === rule.charge_type)

        return !originRule || getChargeAmount(originRule) !== getChargeAmount(rule)
    })
    const decreasedRules = changedRules
        .filter(rule => {
            const originRule = (originRules || []).find(item => item.charge_type === rule.charge_type)

            return !!originRule && getChargeAmount(rule) < getChargeAmount(originRule)
        })
        .sort((a, b) => a.charge_type - b.charge_type)
    const increasedRules = changedRules
        .filter(rule => !decreasedRules.includes(rule))
        .sort((a, b) => b.charge_type - a.charge_type)

    return [...decreasedRules, ...increasedRules]
}

export const validateSvipMemberDiscount = (
    benefitList: number[] = [],
    discountRate?: number | string | null,
    highestOrdinaryDiscountRate?: number | string | null,
) => {
    if (!benefitList.includes(BENEFIT_MEMBER_DISCOUNT)) return ''
    if (discountRate === undefined || discountRate === null || discountRate === '') {
        return '请填写付费会员折扣'
    }

    const numericDiscountRate = Number(discountRate)
    if (Number.isNaN(numericDiscountRate) || numericDiscountRate <= 0 || numericDiscountRate >= 1) {
        return '付费会员折扣率必须大于0且小于1'
    }
    if (
        highestOrdinaryDiscountRate !== undefined &&
        highestOrdinaryDiscountRate !== null &&
        highestOrdinaryDiscountRate !== '' &&
        numericDiscountRate > Number(highestOrdinaryDiscountRate)
    ) {
        return '付费会员折扣率不能高于最高普通会员折扣率'
    }

    return ''
}

export const validateSvipPointMultiplier = (
    benefitList: number[] = [],
    pointMultiplier?: number | string | null,
    highestOrdinaryMultiplier?: number | string | null,
) => {
    if (!benefitList.includes(BENEFIT_POINT_BOOSTER)) return ''
    if (pointMultiplier === undefined || pointMultiplier === null || pointMultiplier === '') {
        return '请填写付费会员积分倍数'
    }
    const numericPointMultiplier = Number(pointMultiplier)
    if (numericPointMultiplier < 1) return '付费会员积分倍数不能小于1'
    if (
        highestOrdinaryMultiplier !== undefined &&
        highestOrdinaryMultiplier !== null &&
        highestOrdinaryMultiplier !== '' &&
        numericPointMultiplier < Number(highestOrdinaryMultiplier)
    ) {
        return '付费会员积分倍数不能小于最高普通会员积分倍数'
    }

    return ''
}
